import { OneColumn } from '@/components/Layout';
import Carousel, { Slides, Slide } from '@/components/Carousel';
import { TrustBox } from '@/pages/Home';
import {
  usePageTranslation,
  PageTranslation,
} from '../../hooks/usePageTranslation';
import {
  ReviewContainerRow,
  ReviewCarouselRow,
  StyledReactMarkdown,
  StyledReviewReactMarkdown,
} from './styled';
import { useMedia } from '@/hooks/useMedia';

export const Reviews = () => {
  const t = usePageTranslation();
  const isDesktop = useMedia(`(min-width: 1024px)`, true);
  return (
    <ReviewContainerRow justifyContent="center" data-cy-id="review">
      <OneColumn>
        <TrustBox boxType="small" />
        <StyledReactMarkdown>
          <h2>
            <PageTranslation i18nKey="reviews.title">
              <strong>Trusted by over</strong> 6 million
              <strong>individual investors worldwide</strong>
            </PageTranslation>
          </h2>
        </StyledReactMarkdown>
      </OneColumn>
      <ReviewCarouselRow>
        <Carousel
          autoPlay
          autoPlaySpeed={10000}
          showDots
          totalSlides={9}
          slidesToScroll={isDesktop ? 5 : 1}
          align={isDesktop ? 'start' : 'center'}
        >
          <Slides>
            <Slide itemsToShow={isDesktop ? 5 : 1}>
              <StyledReviewReactMarkdown>
                <p>
                  <img
                    alt="Dave Saunders Review"
                    src="//images.ctfassets.net/n07nr2koi959/7jBY5qNUQdxxq2D6CUR0aA/18d7ea58e8363e9d343e0b71fd26ad40/dave-saunders.png"
                  />
                  <strong>Dave Saunders</strong>
                  <br />
                  {t('reviews.dave.count')}
                </p>
                <p>
                  <img
                    alt="google-five-stars"
                    src="//images.ctfassets.net/n07nr2koi959/PYN9AbRYZtWDQg8XRJwz9/4e1c74e9991645a64a83b4cfa3a11486/google-five-stars.png"
                  />
                </p>
                <p>{t('reviews.dave.text')}</p>
              </StyledReviewReactMarkdown>
            </Slide>
            <Slide itemsToShow={isDesktop ? 5 : 1}>
              <StyledReviewReactMarkdown>
                <p>
                  <img
                    alt="Patrick Shah Review"
                    src="//images.ctfassets.net/n07nr2koi959/4KFrh6mOTBujmBg5breWmM/92656c5e0988d5d5b4279ff227ad6096/patrick_shah.png"
                  />
                  <strong>Patrick Shah</strong>
                  <br />
                  {t('reviews.patrick.count')}
                </p>
                <p>
                  <img
                    alt="google-five-stars"
                    src="//images.ctfassets.net/n07nr2koi959/PYN9AbRYZtWDQg8XRJwz9/4e1c74e9991645a64a83b4cfa3a11486/google-five-stars.png"
                  />
                </p>
                <p>{t('reviews.patrick.text')}</p>
              </StyledReviewReactMarkdown>
            </Slide>
            <Slide itemsToShow={isDesktop ? 5 : 1}>
              <StyledReviewReactMarkdown>
                <p>
                  <img
                    alt="Wayne Snow Review"
                    src="//images.ctfassets.net/n07nr2koi959/7JZJNFy71yJL4tlRXCsobu/ec001a57e2d22b271dd27edc0c5886b6/wayne-snow.png"
                  />
                  <strong>Wayne Snow</strong>
                  <br />
                  {t('reviews.wayne.count')}
                </p>
                <p>
                  <img
                    alt="google-five-stars"
                    src="//images.ctfassets.net/n07nr2koi959/PYN9AbRYZtWDQg8XRJwz9/4e1c74e9991645a64a83b4cfa3a11486/google-five-stars.png"
                  />
                </p>
                <p>{t('reviews.wayne.text')}</p>
              </StyledReviewReactMarkdown>
            </Slide>
            <Slide itemsToShow={5}>
              <StyledReviewReactMarkdown>
                <p>
                  <img
                    alt="da-wz"
                    src="//images.ctfassets.net/n07nr2koi959/4zBih72QZkBcmknaToNe7N/098a7cd06f7ddbd79ce6de24d0cdd836/da-wz.png"
                  />
                  <strong>DA•Wz</strong>
                  <br />
                  {t('reviews.dawz.handle')}
                </p>
                <p>
                  <img
                    alt="twitter"
                    src="//images.ctfassets.net/n07nr2koi959/tQS9I5Z4PZ4opKPcLpk3V/d8980c9de0931185ad5d4899ab889beb/review-twitter.svg"
                  />
                </p>
                <p>{t('reviews.dawz.text')}</p>
              </StyledReviewReactMarkdown>
            </Slide>
            <Slide itemsToShow={isDesktop ? 5 : 1}>
              <StyledReviewReactMarkdown>
                <p>
                  <img
                    alt="Jacob Review"
                    src="//images.ctfassets.net/n07nr2koi959/2EjOCCSuyZYRm4kxP2o8nl/3c4fad4af0058ddf29a72b785a923c20/jacob-review.png"
                  />
                  <strong>Jacob</strong>
                  <br />
                  {t('reviews.jacob.count')}
                </p>
                <p>
                  <img
                    alt="google-five-stars"
                    src="//images.ctfassets.net/n07nr2koi959/PYN9AbRYZtWDQg8XRJwz9/4e1c74e9991645a64a83b4cfa3a11486/google-five-stars.png"
                  />
                </p>
                <p>{t('reviews.jacob.text')}</p>
              </StyledReviewReactMarkdown>
            </Slide>
            <Slide itemsToShow={isDesktop ? 5 : 1}>
              <StyledReviewReactMarkdown>
                <p>
                  <img
                    alt="Jacob Review"
                    src="//images.ctfassets.net/n07nr2koi959/3gMEnznmFUuCc9ZVNbAYpU/6a4c3171d3744db6cbe25d8ae312ac2a/sara-hofman-review.png"
                  />
                  <strong>Sara Hofmann</strong>
                  <br />
                  {t('reviews.sara.count')}
                </p>
                <p>
                  <img
                    alt="google-five-stars"
                    src="//images.ctfassets.net/n07nr2koi959/PYN9AbRYZtWDQg8XRJwz9/4e1c74e9991645a64a83b4cfa3a11486/google-five-stars.png"
                  />
                </p>
                <p>{t('reviews.sara.text')}</p>
              </StyledReviewReactMarkdown>
            </Slide>
            <Slide itemsToShow={isDesktop ? 5 : 1}>
              <StyledReviewReactMarkdown>
                <p>
                  <img
                    alt="Ian K Review"
                    src="//images.ctfassets.net/n07nr2koi959/5JRUEMawWxYFwkEjMz9lFU/1ffcddd74d69ef7e28b107ec963d65b9/Ian_K.png"
                  />
                  <strong>Ian K</strong>
                  <br />
                  {t('reviews.ian.count')}
                </p>
                <p>
                  <img
                    alt="google-five-stars"
                    src="//images.ctfassets.net/n07nr2koi959/PYN9AbRYZtWDQg8XRJwz9/4e1c74e9991645a64a83b4cfa3a11486/google-five-stars.png"
                  />
                </p>
                <p>{t('reviews.ian.text')}</p>
              </StyledReviewReactMarkdown>
            </Slide>
            <Slide itemsToShow={isDesktop ? 5 : 1}>
              <StyledReviewReactMarkdown>
                <p>
                  <img
                    alt="Jordan H Review"
                    src="//images.ctfassets.net/n07nr2koi959/DDTa6p5c1Shv8eZJbkjQ0/7f8ef0a4c8f6a02f1ea512007f1ce925/Jordan_H.png"
                  />
                  <strong>Jordan H</strong>
                  <br />
                  {t('reviews.jordan.count')}
                </p>
                <p>
                  <img
                    alt="google-five-stars"
                    src="//images.ctfassets.net/n07nr2koi959/PYN9AbRYZtWDQg8XRJwz9/4e1c74e9991645a64a83b4cfa3a11486/google-five-stars.png"
                  />
                </p>
                <p>{t('reviews.jordan.text')}</p>
              </StyledReviewReactMarkdown>
            </Slide>
            <Slide itemsToShow={isDesktop ? 5 : 1}>
              <StyledReviewReactMarkdown>
                <p>
                  <img
                    alt="Jorge Asensio Review"
                    src="//images.ctfassets.net/n07nr2koi959/5NytVQ6kq9GOxyk6knlNms/932e7fb3f64fe1e6aae0bd90f0922c2c/Jorge_Asensio.png"
                  />
                  <strong>Jorge Asensio</strong>
                </p>
                <p>
                  <img
                    alt="google-five-stars"
                    src="//images.ctfassets.net/n07nr2koi959/PYN9AbRYZtWDQg8XRJwz9/4e1c74e9991645a64a83b4cfa3a11486/google-five-stars.png"
                  />
                </p>
                <p>{t('reviews.jorge.text')}</p>
              </StyledReviewReactMarkdown>
            </Slide>
          </Slides>
        </Carousel>
      </ReviewCarouselRow>
    </ReviewContainerRow>
  );
};
